export default "__VITE_ASSET__CSPa5X1F__"